// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IssueFormsHeader = styled.div({
  borderBottom: `1px solid ${"var(--ds-border, #dfe1e5)"}`,
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  margin: `${"var(--ds-space-250, 20px)"} 0`,
  maxWidth: '800px',
  paddingBottom: "var(--ds-space-250, 20px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IssueFormsHeaderWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IssueFormsPickers = styled.div({
  display: 'flex',
  marginTop: "var(--ds-space-150, 12px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div': {
    flex: 1,
    minWidth: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div + div': {
    marginLeft: "var(--ds-space-100, 8px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SectionMessageWrapper = styled.div({
  marginTop: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectOptionContainer = styled.div({
  display: 'inline-flex',
  alignItems: 'top'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectOptionLabelValueWrapper = styled.div({
  marginLeft: "var(--ds-space-050, 4px)",
  display: 'inline-flex',
  alignItems: 'center'
});